export default {
  computed: {
    userGlobalRoles () {
      return this.$oauth2?.me?.roles || [];
    },
    userIsAdmin () {
      return this.userHasGlobalRole('admin');
    },
    userIsSupervisor () {
      return this.userHasGlobalRole('consultant') || this.userHasGlobalRole('supervisor');
    },
    userIsConsultant () {
      return this.userIsSupervisor;
    },
    userIsInvestor () {
      return this.userHasGlobalRole('investor');
    },
  },
  methods: {
    userHasGlobalRole (role) {
      return this.userGlobalRoles.includes(role);
    },
  },
};
